<template>
  <v-dialog
    v-model="mostrar"
    :max-width="'800px'"
    persistent
    scrollable
  >
    <v-card class="modal-principal">
      <v-card-title class="titulo">
        <span>Auditoría</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text
        style="height: 100%;"
        class="pa-0"
      >
        <v-data-table
          :items="datos"
          :headers="cabecera"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td><strong>{{props.item.titulo}}</strong></td>
              <td class="text-xs-left">{{ props.item.usuario ? props.item.usuario.usuario : '--' }}</td>
              <td class="text-xs-right">{{ props.item.fecha }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <botones-cancelar-guardar
          v-bind:mostrar-guardar="false"
          v-on:alCancelar="cerrar"
        ></botones-cancelar-guardar>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EventBus from '@/helpers/eventBus'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'
import Vue from 'vue'
export default {
  name: 'VAuditoria',
  /* filters: {
    formatoFecha
  }, */
  components: {
    BotonesCancelarGuardar
  },
  props: {

  },
  data () {
    return {
      mostrar: false,
      cabecera: [
        {
          text: '',
          align: 'left',
          sortable: false
        },
        { text: 'Usuario', align: 'left', sortable: false },
        { text: 'Fecha', align: 'right', sortable: false }
      ],
      datos: []
    }
  },
  mounted () {
    let vm = this
    EventBus.$on('auditoria:mostrar', (item) => {
      let datosInternos = [
        { titulo: 'Creado', usuario: item.created_by, fecha: item.created_at },
        { titulo: 'Modificado', usuario: item.updated_by, fecha: item.updated_at }
      ]
      Vue.set(vm, 'datos', datosInternos)
      vm.mostrar = true
    })
  },
  beforeDestroy () {
    EventBus.$off('auditoria:mostrar')
  },
  methods: {
    cerrar () {
      this.mostrar = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
